export const CERTIFICATE_FILE_TYPES = ['.pem'];

export type FileUploadStatus = 'idle' | 'uploading' | 'uploaded';

export const UNSAVED_DATA_MODAL_KEYS = {
    title: 'commons.modal.unsaved-data.title',
    descriptionMain: 'commons.modal.unsaved-data.description.main',
    descriptionSecondary: 'commons.modal.unsaved-data.description.secondary',
    buttonText: 'commons.modal.unsaved-data.button.primary',
    continueEditing: 'settings.devices.eap-settings.eap-config-list.action.import.modal.button.continue-editing',
};

export const getFileExtension = (fileName: string): string => {
    const lastDotIndex = fileName.lastIndexOf('.');

    if (lastDotIndex <= 0 || lastDotIndex === fileName.length - 1) {
        return '';
    }

    return fileName.slice(lastDotIndex);
};

export const isValidCertificateFile = (fileName?: string): boolean =>
    !!fileName && CERTIFICATE_FILE_TYPES.includes(getFileExtension(fileName));

export const getFileUploadStatusTranslationKey = (fileStatus: FileUploadStatus, isValid: boolean): string => {
    if (fileStatus === 'uploaded') {
        return isValid
            ? 'settings.devices.eap-settings.eap-config-list.action.import.modal.upload.status.uploaded'
            : 'settings.devices.eap-settings.eap-config-list.action.import.modal.upload.status.invalid';
    }
    return '';
};

export const getFileUploadDisplayText = (
    fileStatus: FileUploadStatus,
    progress: number,
    isValid: boolean,
    translationFunction: (key: string) => string
): string => {
    if (fileStatus === 'uploaded') {
        const translationKey = getFileUploadStatusTranslationKey(fileStatus, isValid);
        return translationFunction(translationKey);
    }
    return `${progress}%`;
};

export const getFileUploadStatusVariant = (
    fileStatus: FileUploadStatus,
    isValid: boolean
): 'default' | 'positive' | 'alarm' => {
    if (fileStatus === 'uploading') {
        return 'default';
    }
    return isValid ? 'positive' : 'alarm';
};
